const basePath = "/user"

const profileRoute = `${basePath}/me`
const subscriptionRoute = `${basePath}/v2/subscriptions`
const installationsRoute = `${basePath}/subscriptions/installations`
const revokeLoginRoute = (userId: number) => `${basePath}/${userId}/revoke`

export default {
	profileRoute,
	subscriptionRoute,
	installationsRoute,
	revokeLoginRoute,
}
